import { Trans } from 'react-i18next'

import simplifiedAnatomyPNG from '~/assets/images/anatomy/simplified-anatomy.png'
import simplifiedAnatomyWEBP from '~/assets/images/anatomy/simplified-anatomy.webp'
import { InfoPageStyles as S } from '~/pages/anatomy/libs/infoPageStyles'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const SimplifiedAnatomy = ({ nextPagePath, pageId }: TPageProps) => {
  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: 'Complex anatomy, beautifully simplified',
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <S.ImageWrapper>
          <picture>
            <source srcSet={simplifiedAnatomyWEBP} type="image/webp" />
            <img src={simplifiedAnatomyPNG} alt="Simplified Anatomy" />
          </picture>
        </S.ImageWrapper>

        <S.Title>
          <Trans ns="anatomy" i18nKey="onboarding.simplifiedAnatomy.title" />
        </S.Title>

        <S.Subtitle>
          <Trans ns="anatomy" i18nKey="onboarding.simplifiedAnatomy.subtitle" />
        </S.Subtitle>

        <S.StyledButton type="button" onClick={() => handleContinue('')}>
          <Trans i18nKey="actions.continue" />
        </S.StyledButton>
      </S.StyledContainer>
    </S.Root>
  )
}

export default SimplifiedAnatomy
